<template>
    <div>
        <psi-card-heading
            headingTitle="Events"
            icon="mdi-calendar-clock"
        ></psi-card-heading>
        <psi-simple-table
            height="350"
            fixed
            dense
            :items="caseDetails.case.events"
            :headers="headers"
        ></psi-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    title: "Event Date",
                    key: "eventDate",
                },
                {
                    title: "Event Type",
                    key: "codeEventType",
                },
                {
                    title: "Comment",
                    key: "comment",
                },
            ],
        };
    },
};
</script>

